module.exports = __webpack_public_path__ + "static/media/lease2_img13.647ee34f.jpg";